import { Result } from 'domain/types';

import { EnableLinkClient } from 'use-case/link/update/updateLinkClient';
import EnableLinkCriteria from 'use-case/link/update/updateLinkCriteria';
import Link from 'domain/entity/link';

export type EnableLinkResult = Result<Link>;
export type EnableLink = (criteria: EnableLinkCriteria) => Promise<EnableLinkResult>;

export const enableLinkUseCase = (enableLinkClient: EnableLinkClient): EnableLink => (
    criteria: EnableLinkCriteria
): Promise<EnableLinkResult> => enableLinkClient(criteria);
